module.exports = __webpack_public_path__ + "img/domain-sale.f07a77b5.svg";